import { useWindowSize } from "../context/WindowSize";
import { maxPhoneWidth, maxTabletWidth } from "../utils/css/mediaQueries";

export default function useBreakpoint() {
  const { width } = useWindowSize();

  const isMobileOnly = width <= maxPhoneWidth;
  const isTabletOnly = width > maxPhoneWidth && width <= maxTabletWidth;
  const isDesktopOnly = width > maxTabletWidth;
  const isMobileOrTablet = isMobileOnly || isTabletOnly;
  const isTabletOrDesktop = isTabletOnly || isDesktopOnly;

  return {
    isMobileOnly,
    isTabletOnly,
    isDesktopOnly,
    isMobileOrTablet,
    isTabletOrDesktop
  };
}
